/**
 * Titre de page propre à chaque écran — RGAA 8.6 (audit du 25/09 : 7 titres pour 20 écrans).
 *
 * Le titre de l'onglet reprend le h1 de l'écran : « Carnet… — VisionPro Collectivité ».
 * Cohabitation avec `usePageTitle` (titre par SECTION) : ce hook repose l'ancien titre en
 * se démontant, APRÈS nous, lors d'une navigation. On surveille donc aussi le <title> et
 * on repose le titre voulu s'il diffère (jamais de boucle : on n'écrit que si différent).
 * Écran sans h1 → on n'écrit rien : le titre de section de `usePageTitle` s'affiche.
 * La surveillance s'arrête 4 s après chaque changement d'adresse.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SUFFIXE = 'VisionPro Collectivité';

export function TitreDePage() {
  const { pathname } = useLocation();
  useEffect(() => {
    const poser = () => {
      const h1 = document.querySelector('h1')?.textContent?.replace(/\s+/g, ' ').trim();
      if (!h1) return;
      const voulu = `${h1.slice(0, 80)} — ${SUFFIXE}`;
      if (document.title !== voulu) document.title = voulu;
    };
    poser();
    const obs = new MutationObserver(poser);
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    const titre = document.querySelector('title');
    if (titre) obs.observe(titre, { childList: true, characterData: true, subtree: true });
    const stop = window.setTimeout(() => obs.disconnect(), 4000);
    return () => { obs.disconnect(); window.clearTimeout(stop); };
  }, [pathname]);
  return null;
}
